import React, { FC, Fragment, ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Unstable_Grid2 as Grid } from '@mui/material';

import BareAppBar from './BareAppBar';
import { useCapabilities, useGlobalClient } from 'hooks';
import { useFormikContext } from 'formik';
import { IExpressActivationValues } from 'features/express/validation';

interface Props {
  form: ReactNode;
  clientInfo: ReactNode;
  meta: {
    renderTermsLink: (type: string) => JSX.Element;
    renderPrivacyPolicyLink: (type: string) => JSX.Element;
    socialAccountTwitterID: string;
    socialAccountLinkedinID: string;
  };
  submitForm: () => void;
}

const ExpressLayout: FC<Props> = ({ clientInfo, form, meta, submitForm }) => {
  const { t } = useTranslation();
  const client = useGlobalClient();
  const {
    renderTermsLink,
    renderPrivacyPolicyLink,
    socialAccountLinkedinID,
    socialAccountTwitterID,
  } = meta;
  const { values, isValid } = useFormikContext<IExpressActivationValues>();
  const { email } = values;
  const { needs } = useCapabilities();

  useEffect(() => {
    if (email && isValid && (socialAccountLinkedinID || socialAccountTwitterID)) {
      submitForm();
    }
  }, [socialAccountTwitterID, socialAccountLinkedinID, email, isValid]);

  function redirect() {
    window.location.href = `https://${client.subdomain}`;
  }

  if (!needs('Invitation.Function.ExpressActivation')) {
    redirect();
    return null;
  }

  function renderContactLink() {
    return (
      <Link href="https://everyonesocial.com/contact" target="_blank" underline="hover">
        {t('auth:contactUs')}
      </Link>
    );
  }

  return (
    <Fragment>
      <BareAppBar />
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={2}
        minHeight="100vh"
        sx={{ backgroundColor: 'common.white' }}
      >
        <Grid xs={12} container justifyContent="center" alignItems="center">
          <Grid xs={4} container>
            {clientInfo}{' '}
          </Grid>
          <Grid>{form}</Grid>
        </Grid>
        <Grid container>
          <Grid>
            {renderTermsLink('footer')} & {renderPrivacyPolicyLink('footer')}
          </Grid>
          <Grid>{renderContactLink()}</Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default ExpressLayout;
